var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"has-text-centered mb-4"},[_c('PointInfo',{attrs:{"point":_vm.pointTransfer.point,"label":`交換${_vm.$t('keyword.point')}`,"color":"#F14668"}})],1),(_vm.customerCoupon)?_c('CustomerCoupon',{attrs:{"customer-coupon":_vm.customerCoupon}}):_c('SkeltonCoupon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }